import DashboardLayout from '@/pages/Shared/Layout/DashboardLayout.vue'

import Login from '@/pages/Login.vue'

// Dashboard pages
import Dashboard from '@/pages/Dashboard.vue'
import RiskAndQuality from '@/pages/RiskAndQuality/routes'
import Administrative from '@/pages/Administrative/routes'
import Reviews from '@/pages/Reviews/routes'
import Report from '@/pages/Report/routes'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    meta: {
      profiles: ['user', 'admin', 'adminTi']
    }
  },
  {
    path: '/',
    component: DashboardLayout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        components: {default: Dashboard},
        meta: {
          profiles: ['user', 'admin', 'adminTi']
        }
      },
      ...RiskAndQuality,
      ...Administrative,
      ...Reviews
    ]
  },
  {
    path: '/report',
    component: DashboardLayout,
    children: [
      ...Report,
    ]
  }
]

export default routes
